// Generated from SVG to Code Figma Plugin
'use client';
import React from 'react';
import { chakra } from '@chakra-ui/react';
import { useColorMode } from '@/components/ui/color-mode';

type Props = {
  width?: number;
  fill?: string;
};
export const Share = ({ fill = 'none', width = 11 }: Props) => {
  const { colorMode } = useColorMode();
  const fillColor = colorMode === 'light' ? 'black' : 'white';
  return (
    <chakra.svg
      width={`${width}px`}
      height={`${width}px`}
      viewBox="0 0 11 12"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
    >
      <path
        d="M4.66667 0V1.33333H1.33333V10.6667H10.6667V7.33333H12V11.3333C12 11.7015 11.7015 12 11.3333 12H0.666667C0.29848 12 0 11.7015 0 11.3333V0.666667C0 0.29848 0.29848 0 0.666667 0H4.66667ZM9.72387 1.33333H6.66667V0H12V5.33333H10.6667V2.27614L6 6.9428L5.0572 6L9.72387 1.33333Z"
        fill={fillColor}
        fillOpacity="0.6"
      />
    </chakra.svg>
  );
};
